import { Reveal, Overline } from "./Reveal";
import { mediaUrl } from "../../lib/api";
import { User } from "lucide-react";

export default function Team({ team }) {
  return (
    <section id="equipo" className="relative py-28 sm:py-36 bg-jauja-surface" data-testid="team-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>{team.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-medium tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl">
              {team.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {(team.members || []).map((m, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}>
              <div className="group relative overflow-hidden rounded-2xl border border-white/10" data-testid="team-member">
                <div className="aspect-[3/4] overflow-hidden bg-jauja-bg">
                  {m.photo ? (
                    <img
                      src={mediaUrl(m.photo)}
                      alt={m.name}
                      className="h-full w-full object-cover grayscale transition-[filter,transform] duration-500 group-hover:grayscale-0 group-hover:scale-105"
                    />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center bg-gradient-to-b from-white/5 to-transparent">
                      <User className="text-white/15" size={72} strokeWidth={1} />
                    </div>
                  )}
                </div>
                <div className="absolute bottom-3 left-3 right-3 rounded-xl border border-white/10 bg-jauja-bg/70 backdrop-blur-md p-4">
                  <h3 className="font-display text-xl text-white">{m.name || "Nombre del integrante"}</h3>
                  {m.role && <p className="mt-1 text-sm text-jauja-lime">{m.role}</p>}
                  {m.background && <p className="mt-1 text-xs text-white/50">{m.background}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
